// MYOTIDE Theme - Base JS
(function() {
  'use strict';

  // FIX 1 (lock 2026-05-24): Disable browser auto-scroll-restoration on reload.
  // Mobile Safari aggressively restores scroll position even after a hard-reload,
  // which the user perceives as "page auto-scrolls down a bit on its own."
  if ('scrollRestoration' in history) {
    history.scrollRestoration = 'manual';
  }

  // FIX 2 (lock 2026-05-24): Strip "#pdp-hero" (or any) hash on page load so the
  // browser doesn't auto-scroll to that anchor on hard-reload.
  // Then force-reset scroll to top so we always start clean.
  if (location.hash) {
    history.replaceState(null, '', location.pathname + location.search);
  }
  // Defer to next frame so initial render is at scroll-top:
  window.scrollTo(0, 0);

  // Header behavior (lock 2026-05-24 v6 — natural flow + floating clone):
  //   - Original header is in natural flow and scrolls away with the page (no swipe)
  //   - A floating CLONE is added to <body>, initially hidden above the viewport
  //   - Scroll UP past original header → clone slides in from top
  //   - Scroll DOWN → clone slides back out
  //   - At top zone (original header still in view) → clone stays hidden
  //
  // Clone strategy avoids any toggle/jump issues that come with switching
  // a single element between `position: relative` and `position: fixed`.
  const header = document.querySelector('.header');
  const announcement = document.querySelector('.announcement');
  if (header && !document.querySelector('.header-floating')) {
    // Clone the header for the floating "appear on scroll-up" experience
    const floating = header.cloneNode(true);
    floating.classList.add('header-floating');
    floating.setAttribute('aria-hidden', 'true');
    // Strip IDs from clone to avoid duplicate-ID conflicts
    if (floating.id) floating.removeAttribute('id');
    floating.querySelectorAll('[id]').forEach(el => el.removeAttribute('id'));
    document.body.appendChild(floating);

    let lastY = window.scrollY;
    let ticking = false;
    let scrollAcc = 0;
    const TRIGGER = 5;

    function update() {
      const curY = window.scrollY;
      const delta = curY - lastY;
      const headerBottom = header.offsetTop + header.offsetHeight;

      // Direction-change resets accumulator (prevents wiggle-jitter)
      if ((delta > 0 && scrollAcc < 0) || (delta < 0 && scrollAcc > 0)) {
        scrollAcc = 0;
      }
      scrollAcc += delta;

      if (curY < headerBottom) {
        // Original header still partially/fully visible → keep clone hidden
        floating.classList.remove('is-visible');
      } else if (scrollAcc < -TRIGGER) {
        // Scrolling UP past original → show floating clone
        floating.classList.add('is-visible');
      } else if (scrollAcc > TRIGGER) {
        // Scrolling DOWN → hide floating clone
        floating.classList.remove('is-visible');
      }

      lastY = curY;
      ticking = false;
    }

    window.addEventListener('scroll', () => {
      if (!ticking) { requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
  }
})();


/* === Homepage JS (extracted from homepage-LATEST.html) === */


(function() {
  const tl = document.querySelector('.variant-b .vb-timeline');
  if (!tl) return;
  const fill = tl.querySelector('.vb-line-fill');
  const steps = tl.querySelectorAll('.vb-step');
  const markers = tl.querySelectorAll('.vb-marker');
  if (!fill || !steps.length) return;

  let raf = null;
  function update() {
    raf = null;
    const tlRect = tl.getBoundingClientRect();
    const viewportH = window.innerHeight;
    const center = viewportH * 0.50;

    // Progress: 0 when timeline-top is at center, 1 when timeline-bottom is at center
    const progress = Math.max(0, Math.min(1,
      (center - tlRect.top) / Math.max(tlRect.height, 1)
    ));
    fill.style.height = (progress * 100).toFixed(2) + '%';

    // Find step whose vertical center is closest to viewport center (and currently in view)
    let bestIdx = -1;
    let bestDist = Infinity;
    steps.forEach((step, i) => {
      const r = step.getBoundingClientRect();
      const stepCenter = r.top + r.height / 2;
      const dist = Math.abs(stepCenter - center);
      // Only count if reasonably close to viewport
      if (stepCenter < viewportH + 100 && stepCenter > -100 && dist < bestDist) {
        bestDist = dist;
        bestIdx = i;
      }
    });

    markers.forEach((m, i) => {
      m.classList.remove('is-current', 'is-passed');
      if (bestIdx === -1) return;
      if (i === bestIdx) m.classList.add('is-current');
      else if (i < bestIdx) m.classList.add('is-passed');
    });
  }

  function onScroll() {
    if (raf == null) raf = requestAnimationFrame(update);
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  update();
})();



(function(){
  const track = document.getElementById('frTrack');
  const prevBtn = document.getElementById('frPrev');
  const nextBtn = document.getElementById('frNext');
  const fill = document.getElementById('frProgressFill');
  if (!track || !prevBtn || !nextBtn) return;

  // --- Snapshot the 5 real cards, then build [5 pre-clones | 5 real | 5 post-clones] ---
  const realCards = Array.from(track.querySelectorAll('.fr-card'));
  const N = realCards.length;
  if (N === 0) return;
  // Remove any previous clones (idempotent if script re-runs)
  track.querySelectorAll('.fr-card[data-clone]').forEach(c => c.remove());

  const preFrag = document.createDocumentFragment();
  realCards.forEach(c => { const clone = c.cloneNode(true); clone.dataset.clone = 'pre'; clone.setAttribute('aria-hidden', 'true'); preFrag.appendChild(clone); });
  track.insertBefore(preFrag, track.firstChild);

  realCards.forEach(c => { const clone = c.cloneNode(true); clone.dataset.clone = 'post'; clone.setAttribute('aria-hidden', 'true'); track.appendChild(clone); });

  // Track layout: slots 0..4 = pre-clones, 5..9 = real, 10..14 = post-clones
  // Initial position: slot N (=5) showing real-1
  let currentSlot = N;
  let isAnimating = false;
  let step = 0;
  let lastRealIdx = 0;

  function calcStep() {
    const card = track.querySelector('.fr-card');
    if (!card) return 0;
    const style = getComputedStyle(track);
    const gap = parseFloat(style.columnGap || style.gap || '0') || 0;
    step = card.getBoundingClientRect().width + gap;
    return step;
  }

  function applyTransform(animate, extraOffset) {
    track.style.transition = animate ? 'transform 0.42s cubic-bezier(0.4, 0, 0.2, 1)' : 'none';
    const offset = (extraOffset || 0);
    track.style.transform = `translate3d(${(-currentSlot * step) + offset}px, 0, 0)`;
  }

  function updateProgress() {
    const realIdx = ((currentSlot - N) % N + N) % N;
    const ratio = N > 1 ? realIdx / (N - 1) : 0;
    if (fill) {
      // When wrapping (idx jumps by more than 1 = loop boundary), snap silently
      // instead of letting the fill sweep backward across the bar.
      const isWrap = Math.abs(realIdx - lastRealIdx) > 1;
      if (isWrap) {
        fill.style.transition = 'none';
        fill.style.transform = `translateX(${(ratio * 400).toFixed(2)}%)`;
        void fill.offsetWidth; // force reflow
        requestAnimationFrame(() => { fill.style.transition = 'transform .3s ease'; });
      } else {
        fill.style.transform = `translateX(${(ratio * 400).toFixed(2)}%)`;
      }
    }
    lastRealIdx = realIdx;
  }

  function teleportIfNeeded() {
    // After animation, if we landed on a clone, jump silently to the equivalent real position
    if (currentSlot >= N * 2) {
      currentSlot -= N;
      applyTransform(false);
    } else if (currentSlot < N) {
      currentSlot += N;
      applyTransform(false);
    }
  }

  function goNext() {
    if (isAnimating) return;
    isAnimating = true;
    currentSlot++;
    applyTransform(true);
    updateProgress();
    setTimeout(() => { teleportIfNeeded(); isAnimating = false; }, 430);
  }

  function goPrev() {
    if (isAnimating) return;
    isAnimating = true;
    currentSlot--;
    applyTransform(true);
    updateProgress();
    setTimeout(() => { teleportIfNeeded(); isAnimating = false; }, 430);
  }

  nextBtn.addEventListener('click', goNext);
  prevBtn.addEventListener('click', goPrev);

  // --- Pointer-based drag/swipe (covers touch + mouse + pen) ---
  let pointerActive = false;
  let pointerStartX = 0;
  let pointerStartY = 0;
  let lockedAxis = null; // 'x' | 'y' | null
  let pointerStartTime = 0;
  let lastDrag = 0;

  track.addEventListener('pointerdown', (e) => {
    if (isAnimating) return;
    pointerStartX = e.clientX;
    pointerStartY = e.clientY;
    lockedAxis = null;
    pointerStartTime = Date.now();
    lastDrag = 0;
    pointerActive = true;
    track.style.transition = 'none';
    try { track.setPointerCapture(e.pointerId); } catch (err) {}
  });

  track.addEventListener('pointermove', (e) => {
    if (!pointerActive) return;
    const dx = e.clientX - pointerStartX;
    const dy = e.clientY - pointerStartY;
    // Determine drag direction with a 6px deadzone
    if (lockedAxis === null) {
      if (Math.abs(dx) > 6 || Math.abs(dy) > 6) {
        lockedAxis = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';
      }
    }
    if (lockedAxis === 'x') {
      lastDrag = dx;
      applyTransform(false, lastDrag);
      // Prevent default scrolling on horizontal drag
      if (e.cancelable && typeof e.preventDefault === 'function') e.preventDefault();
    }
  });

  function endPointer(e) {
    if (!pointerActive) return;
    pointerActive = false;
    try { if (e && e.pointerId !== undefined) track.releasePointerCapture(e.pointerId); } catch (err) {}
    if (lockedAxis !== 'x') {
      // No horizontal drag → ignore
      return;
    }
    const elapsed = Date.now() - pointerStartTime;
    const velocity = Math.abs(lastDrag) / Math.max(elapsed, 1);
    const swipeThreshold = step * 0.18; // 18% of card width
    const velocityThreshold = 0.35; // px/ms
    if (Math.abs(lastDrag) > swipeThreshold || velocity > velocityThreshold) {
      if (lastDrag < 0) goNext();
      else goPrev();
    } else {
      // Snap back
      applyTransform(true);
    }
  }

  track.addEventListener('pointerup', endPointer);
  track.addEventListener('pointercancel', endPointer);
  track.addEventListener('pointerleave', (e) => { if (pointerActive) endPointer(e); });

  // Visual cue on desktop
  track.style.cursor = 'grab';
  track.addEventListener('pointerdown', () => { track.style.cursor = 'grabbing'; });
  track.addEventListener('pointerup', () => { track.style.cursor = 'grab'; });
  track.addEventListener('pointercancel', () => { track.style.cursor = 'grab'; });

  // --- Trackpad horizontal scroll (wheel events with deltaX) ---
  let wheelOffset = 0;
  let wheelEndTimer = null;

  function endWheel() {
    if (Math.abs(wheelOffset) < 4) {
      applyTransform(true);
      wheelOffset = 0;
      return;
    }
    // Determine how many cards to advance based on accumulated offset
    const cardsToMove = Math.round(-wheelOffset / step);
    if (cardsToMove === 0) {
      // Drag was not large enough → snap back to current slot
      applyTransform(true);
    } else {
      isAnimating = true;
      currentSlot += cardsToMove;
      applyTransform(true);
      updateProgress();
      setTimeout(() => { teleportIfNeeded(); isAnimating = false; }, 430);
    }
    wheelOffset = 0;
  }

  track.addEventListener('wheel', (e) => {
    if (isAnimating) return;
    // Only intercept if horizontal scroll is dominant (trackpad gesture)
    if (Math.abs(e.deltaX) <= Math.abs(e.deltaY)) return;
    e.preventDefault();
    wheelOffset -= e.deltaX;
    track.style.transition = 'none';
    track.style.transform = `translate3d(${(-currentSlot * step) + wheelOffset}px, 0, 0)`;
    clearTimeout(wheelEndTimer);
    wheelEndTimer = setTimeout(endWheel, 120);
  }, { passive: false });

  // --- Resize ---
  function onResize() {
    calcStep();
    applyTransform(false);
  }
  window.addEventListener('resize', onResize);

  // --- Init with retry (in case layout not ready first frame) ---
  function init() {
    calcStep();
    if (step <= 0) {
      requestAnimationFrame(init);
      return;
    }
    applyTransform(false);
    updateProgress();
  }
  requestAnimationFrame(() => requestAnimationFrame(init));
})();



// Hero-Switcher (preview-tool - toggles hero variant via body[data-hero])
(function() {
  const KEY = 'myotide_hero_variant';
  const buttons = document.querySelectorAll('.hsw-btn');
  const stored = localStorage.getItem(KEY) || 'v1';
  function setVariant(v) {
    document.body.setAttribute('data-hero', v);
    buttons.forEach(b => b.classList.toggle('active', b.dataset.hero === v));
    localStorage.setItem(KEY, v);
  }
  setVariant(stored);
  buttons.forEach(btn => {
    btn.addEventListener('click', () => setVariant(btn.dataset.hero));
  });
})();



// Mobile Drawer toggle (lock 2026-05-24 v2 — guarded, event-delegated)
// Idempotent: even if this IIFE appears twice in the file (legacy), the guard
// prevents double-binding which used to make the burger button toggle-then-close
// instantly (net effect: nothing happened visually).
(function() {
  if (window.__MYOTIDE_DRAWER_INIT__) return;
  window.__MYOTIDE_DRAWER_INIT__ = true;

  function openDrawer() {
    const drawer = document.querySelector('.mobile-drawer');
    const overlay = document.querySelector('.mobile-drawer-overlay');
    if (!drawer || !overlay) return;
    drawer.classList.add('open');
    overlay.removeAttribute('hidden');
    overlay.classList.add('open');
    drawer.setAttribute('aria-hidden', 'false');
    document.querySelectorAll('.mobile-menu-btn').forEach(b => b.setAttribute('aria-expanded', 'true'));
    document.body.classList.add('drawer-open');
  }
  function closeDrawer() {
    const drawer = document.querySelector('.mobile-drawer');
    const overlay = document.querySelector('.mobile-drawer-overlay');
    if (!drawer || !overlay) return;
    drawer.classList.remove('open');
    overlay.classList.remove('open');
    drawer.setAttribute('aria-hidden', 'true');
    document.querySelectorAll('.mobile-menu-btn').forEach(b => b.setAttribute('aria-expanded', 'false'));
    document.body.classList.remove('drawer-open');
  }

  document.addEventListener('click', function(e) {
    if (e.target.closest('.mobile-menu-btn')) {
      e.preventDefault();
      const drawer = document.querySelector('.mobile-drawer');
      if (drawer && drawer.classList.contains('open')) closeDrawer();
      else openDrawer();
      return;
    }
    if (e.target.closest('.mobile-drawer-close')) { e.preventDefault(); closeDrawer(); return; }
    if (e.target.classList && e.target.classList.contains('mobile-drawer-overlay')) { closeDrawer(); return; }
    if (e.target.closest('.mobile-drawer-link')) { closeDrawer(); /* navigation continues */ }
  });

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') closeDrawer();
  });
})();
// NOTE: Duplicate header scroll-handler removed here (lock 2026-05-24, second instance).
// The proper 2-stage handler lives at the top of this file.



/* Clear any old hero variant override from previous dev-toggle */
(function() {
  try { localStorage.removeItem('myotide-hero-variant'); } catch(e) {}
  document.body.removeAttribute('data-hero');
})();


/* === PDP JS (extracted from product-page-LATEST.html) === */


(function() {
  const tl = document.querySelector('.variant-b .vb-timeline');
  if (!tl) return;
  const fill = tl.querySelector('.vb-line-fill');
  const steps = tl.querySelectorAll('.vb-step');
  const markers = tl.querySelectorAll('.vb-marker');
  if (!fill || !steps.length) return;

  let raf = null;
  function update() {
    raf = null;
    const tlRect = tl.getBoundingClientRect();
    const viewportH = window.innerHeight;
    const center = viewportH * 0.50;

    // Progress: 0 when timeline-top is at center, 1 when timeline-bottom is at center
    const progress = Math.max(0, Math.min(1,
      (center - tlRect.top) / Math.max(tlRect.height, 1)
    ));
    fill.style.height = (progress * 100).toFixed(2) + '%';

    // Find step whose vertical center is closest to viewport center (and currently in view)
    let bestIdx = -1;
    let bestDist = Infinity;
    steps.forEach((step, i) => {
      const r = step.getBoundingClientRect();
      const stepCenter = r.top + r.height / 2;
      const dist = Math.abs(stepCenter - center);
      // Only count if reasonably close to viewport
      if (stepCenter < viewportH + 100 && stepCenter > -100 && dist < bestDist) {
        bestDist = dist;
        bestIdx = i;
      }
    });

    markers.forEach((m, i) => {
      m.classList.remove('is-current', 'is-passed');
      if (bestIdx === -1) return;
      if (i === bestIdx) m.classList.add('is-current');
      else if (i < bestIdx) m.classList.add('is-passed');
    });
  }

  function onScroll() {
    if (raf == null) raf = requestAnimationFrame(update);
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  update();
})();




// (Duplicate frTrack carousel IIFE removed 2026-05-27 — was double-binding listeners + double-cloning cards · caused 35-card track, mismatched teleport timings, 'weird jump'. Original IIFE at line ~137 is the live one.)




// PDP: Pricing Plan Radio + Sticky Cart + Dynamic Buy Once + Sub Qty
(function() {
  const plans = document.querySelectorAll('.pdp-plan');
  const stickyPlan = document.getElementById('pdp-sticky-plan');
  const onetimeLabel = document.getElementById('pdp-onetime-label');
  const onetimeQty = document.getElementById('pdp-onetime-qty');
  const subQty = document.getElementById('pdp-sub-quantity');
  if (!plans.length) return;

  // Per-interval data: sticky bar label + one-time label/qty + subscription qty
  // qty matches months in plan so cart subtotal = monthly_price × months
  // Each Loop plan is bound to ONE variant (MYO-001 / MYO-002 / MYO-003 = 1/3/6 bag packs).
  // PLAN_DATA holds only display labels; variant_id + onetime label now come from the radio's
  // data-* attributes (see Liquid in pdp-hero.liquid). qty is always 1 because the variant IS
  // the pack-size — we no longer multiply MYO-001 × N.
  const PLAN_DATA = {
    "1": { sticky: "Monthly · $69.90/mo"  },
    "3": { sticky: "3 Months · $59.90/mo" },
    "6": { sticky: "6 Months · $49.90/mo" }
  };

  // Cache the two hidden variant inputs (subscription + one-time)
  const subVariantInput = document.querySelector('#pdp-product-form input[name="id"]');
  const otVariantInput  = document.querySelector('#pdp-onetime-form input[name="id"]');
  const freebiesParentId  = document.querySelectorAll('#pdp-product-form .parent-variant-id');

  function selectPlan(planEl) {
    plans.forEach(p => {
      const isMatch = p === planEl;
      p.classList.toggle('pdp-plan-selected', isMatch);
      const radio = p.querySelector('.pdp-plan-radio');
      if (radio) radio.checked = isMatch;
    });
    const radio = planEl.querySelector('.pdp-plan-radio');
    if (!radio) return;
    const interval     = radio.dataset.interval || '3';
    const variantId    = radio.dataset.variantId || '';
    const onetimeVarId = radio.dataset.onetimeVariantId || variantId;
    const onetimeQtyV  = radio.dataset.onetimeQty || '1';
    const onetimeText  = radio.dataset.onetimeLabel || '';
    const data         = PLAN_DATA[interval];
    if (data && stickyPlan) stickyPlan.textContent = data.sticky;
    if (onetimeText && onetimeLabel) onetimeLabel.textContent = onetimeText;
    // Subscription form: variant = bound variant (MYO-001/002/003), qty = 1
    if (subVariantInput && variantId)    subVariantInput.value = variantId;

    // Dm - Changes || 15/07/26 Start =====
    if (subVariantInput && variantId) {
      freebiesParentId.forEach(item => {
        item.value = variantId;
      })
    }
    // Dm - Changes || 15/07/26 End =====

    if (subQty)                          subQty.value = 1;
    // One-time form: variant = MYO-001 (single bag), qty = bag count (1/3/6)
    if (otVariantInput  && onetimeVarId) otVariantInput.value  = onetimeVarId;
    if (onetimeQty)                      onetimeQty.value = onetimeQtyV;
  }

  plans.forEach(p => {
    p.addEventListener('click', (e) => {
      if (e.target.classList && e.target.classList.contains('pdp-plan-radio')) return;
      selectPlan(p);
    });
    const radio = p.querySelector('.pdp-plan-radio');
    if (radio) radio.addEventListener('change', () => selectPlan(p));
  });

  const checked = document.querySelector('.pdp-plan-radio:checked');
  if (checked) selectPlan(checked.closest('.pdp-plan'));
})();

// Homepage Preserve Stack — swipeable gallery + dot sync (lock 2026-05-25)
(function() {
  const track = document.getElementById('ps-gallery-track');
  const dotsWrap = document.getElementById('ps-dots');
  if (!track || !dotsWrap) return;
  const dots = dotsWrap.querySelectorAll('.ps-dot');
  if (!dots.length) return;

  let ticking = false;
  function updateActive() {
    const idx = Math.round(track.scrollLeft / track.clientWidth);
    dots.forEach((d, i) => d.classList.toggle('ps-dot-active', i === idx));
    ticking = false;
  }
  track.addEventListener('scroll', () => {
    if (!ticking) { requestAnimationFrame(updateActive); ticking = true; }
  }, { passive: true });

  dots.forEach((dot, i) => {
    dot.addEventListener('click', (e) => {
      e.preventDefault();
      track.scrollTo({ left: track.clientWidth * i, behavior: 'smooth' });
    });
  });
})();

// PDP: Image Gallery Thumbnail Selector
// PDP Image Gallery: thumb-click ↔ main-slide sync (lock 2026-05-28)
// Desktop: thumb click adds .active to corresponding slide (fade-stack)
// Mobile:  thumb click scrolls main carousel to that slide · swipe in main
//          carousel auto-updates active thumb via IntersectionObserver
(function() {
  const thumbs = document.querySelectorAll('.pdp-thumb');
  const slides = document.querySelectorAll('.pdp-slide');
  const gallery = document.getElementById('pdp-gallery-main');
  if (!thumbs.length || !slides.length || !gallery) return;

  function setActive(key) {
    thumbs.forEach(t => t.classList.toggle('active', t.dataset.key === key));
    slides.forEach(s => s.classList.toggle('active', s.dataset.key === key));
  }

  // Thumb click → activate slide + (mobile) scroll carousel to it
  thumbs.forEach(t => {
    t.addEventListener('click', () => {
      const key = t.dataset.key;
      if (!key) return;
      setActive(key);
      const slide = Array.from(slides).find(s => s.dataset.key === key);
      if (slide && window.matchMedia('(max-width: 768px)').matches) {
        slide.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
      }
    });
  });

  // Mobile: detect which slide is most-visible during swipe → sync active thumb
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver((entries) => {
      if (!window.matchMedia('(max-width: 768px)').matches) return;
      entries.forEach(entry => {
        if (entry.isIntersecting && entry.intersectionRatio >= 0.6) {
          const key = entry.target.dataset.key;
          if (key) setActive(key);
        }
      });
    }, { root: gallery, threshold: [0.6] });
    slides.forEach(s => io.observe(s));
  }
})();

// PDP: Sticky Add-to-Cart Bar (mobile · appears after scroll-past hero)
(function() {
  const bar = document.getElementById('pdp-sticky-cart');
  const hero = document.getElementById('pdp-hero');
  if (!bar || !hero) return;
  let ticking = false;

  // ═══════════════════════════════════════════════════════════════════════════
  // ⚠ iOS DYNAMIC-TOOLBAR PIN (lock 2026-05-29 · DO NOT REVERT WITHOUT TESTING)
  // ═══════════════════════════════════════════════════════════════════════════
  // Bug (confirmed on iOS Chrome 2026-05-29): when the browser auto-hides its
  // bottom toolbar on scroll-down (full-screen mode), `position:fixed; bottom:0`
  // does NOT re-anchor to the now-taller visible area → the bar "hängt in der
  // Luft" with page content peeking below it. When the toolbar is visible the
  // bar sits correctly (so it's purely the toolbar-collapse that breaks it).
  //
  // Fix: on every visualViewport resize/scroll, explicitly set `bottom` to the
  // inset between layout-viewport bottom and visual-viewport bottom. The act of
  // setting it via JS also FORCES iOS to recompute the anchor (the core fix).
  // Only `bottom` is touched — the slide-in transform (translateY) stays intact.
  // Skips during pinch-zoom (scale > 1) so it doesn't fight the zoom.
  function pinStickyBar() {
    const vv = window.visualViewport;
    if (!vv) return;
    if (vv.scale > 1.01) { bar.style.bottom = '0px'; return; }
    const inset = window.innerHeight - vv.height - vv.offsetTop;
    bar.style.bottom = (inset > 0 ? inset : 0) + 'px';
  }

  function update() {
    const heroBottom = hero.getBoundingClientRect().bottom;
    const showBar = heroBottom < 80;
    bar.classList.toggle('visible', showBar);
    bar.setAttribute('aria-hidden', showBar ? 'false' : 'true');
    // Reserve body padding only WHILE the bar is visible — avoids dead
    // whitespace below footer when the bar is off-screen.
    document.body.classList.toggle('has-sticky-cart', showBar);
    pinStickyBar();
    ticking = false;
  }
  window.addEventListener('scroll', () => {
    if (!ticking) { requestAnimationFrame(update); ticking = true; }
  }, { passive: true });
  if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', pinStickyBar);
    window.visualViewport.addEventListener('scroll', pinStickyBar);
  }
  update();
})();



// Ingredients Popup
(function() {
  const trigger = document.getElementById('pdp-ingredients-trigger');
  const modal = document.getElementById('pdp-ing-modal');
  const closeBtn = document.getElementById('pdp-ing-close');
  if (!trigger || !modal || !closeBtn) return;
  function open() { modal.classList.add('open'); document.body.style.overflow = 'hidden'; }
  function close() { modal.classList.remove('open'); document.body.style.overflow = ''; }
  trigger.addEventListener('click', open);
  closeBtn.addEventListener('click', close);
  modal.addEventListener('click', (e) => { if (e.target === modal) close(); });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && modal.classList.contains('open')) close(); });
})();



// Mobile Drawer toggle (lock 2026-05-24 v2 — guarded, event-delegated)
// Idempotent: even if this IIFE appears twice in the file (legacy), the guard
// prevents double-binding which used to make the burger button toggle-then-close
// instantly (net effect: nothing happened visually).
(function() {
  if (window.__MYOTIDE_DRAWER_INIT__) return;
  window.__MYOTIDE_DRAWER_INIT__ = true;

  function openDrawer() {
    const drawer = document.querySelector('.mobile-drawer');
    const overlay = document.querySelector('.mobile-drawer-overlay');
    if (!drawer || !overlay) return;
    drawer.classList.add('open');
    overlay.removeAttribute('hidden');
    overlay.classList.add('open');
    drawer.setAttribute('aria-hidden', 'false');
    document.querySelectorAll('.mobile-menu-btn').forEach(b => b.setAttribute('aria-expanded', 'true'));
    document.body.classList.add('drawer-open');
  }
  function closeDrawer() {
    const drawer = document.querySelector('.mobile-drawer');
    const overlay = document.querySelector('.mobile-drawer-overlay');
    if (!drawer || !overlay) return;
    drawer.classList.remove('open');
    overlay.classList.remove('open');
    drawer.setAttribute('aria-hidden', 'true');
    document.querySelectorAll('.mobile-menu-btn').forEach(b => b.setAttribute('aria-expanded', 'false'));
    document.body.classList.remove('drawer-open');
  }

  document.addEventListener('click', function(e) {
    if (e.target.closest('.mobile-menu-btn')) {
      e.preventDefault();
      const drawer = document.querySelector('.mobile-drawer');
      if (drawer && drawer.classList.contains('open')) closeDrawer();
      else openDrawer();
      return;
    }
    if (e.target.closest('.mobile-drawer-close')) { e.preventDefault(); closeDrawer(); return; }
    if (e.target.classList && e.target.classList.contains('mobile-drawer-overlay')) { closeDrawer(); return; }
    if (e.target.closest('.mobile-drawer-link')) { closeDrawer(); /* navigation continues */ }
  });

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') closeDrawer();
  });
})();
// NOTE: Duplicate header scroll-handler removed (lock 2026-05-24).
// The proper 2-stage handler (announcement bar + header) lives at the very top of this file.
// Having TWO handlers caused conflicts where the duplicate would re-show the header
// while the first one was hiding it (and vice versa).

// === CTA Button Handlers (smooth-scroll + cart actions) ===
(function() {
  // Smooth-scroll all anchor links to #pdp-hero
  document.querySelectorAll('a[href="#pdp-hero"]').forEach(a => {
    a.addEventListener('click', (e) => {
      const target = document.getElementById('pdp-hero');
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        // FIX: Do NOT set history hash here — it causes auto-scroll on hard-reload (mobile).
        // The smooth-scroll above is enough; the URL stays clean.
      }
    });
  });

  // Defensive: Re-sync VARIANT-ID + QTY from currently-selected plan-radio just
  // before submit. Differs between subscription form vs one-time form:
  //   - Subscription: variant = bound variant (MYO-001/002/003), qty = 1
  //   - One-time:     variant = MYO-001 (single bag), qty = bag count (1/3/6)
  // (lock 2026-05-27 v3)
  function syncQtyFromCheckedPlan(form, qtyInputId, isOnetime) {
    const checkedRadio = form.querySelector('.pdp-plan-radio:checked')
                     || document.querySelector('.pdp-plan-radio:checked');
    const qtyInput = document.getElementById(qtyInputId);
    if (!qtyInput || !checkedRadio) return;
    const varInput = form.querySelector('input[name="id"]');
    if (isOnetime) {
      qtyInput.value = checkedRadio.dataset.onetimeQty || '1';
      const otVariantId = checkedRadio.dataset.onetimeVariantId;
      if (varInput && otVariantId) varInput.value = otVariantId;
    } else {
      qtyInput.value = '1';
      const subVariantId = checkedRadio.dataset.variantId;
      if (varInput && subVariantId) varInput.value = subVariantId;
    }
  }

  // Add to Cart: Submit form via AJAX, then open drawer
  const productForm = document.getElementById('pdp-product-form');
  if (productForm) {
    productForm.addEventListener('submit', (ev) => {
      ev.preventDefault();
      syncQtyFromCheckedPlan(productForm, 'pdp-sub-quantity', false);
      // DEBUG (lock 2026-05-28): log what's actually being sent to /cart/add.js
      // — if user reports wrong plan in cart, this surfaces variant/plan mismatch.
      const fd = new FormData(productForm);
      console.log('[PDP submit]', {
        id: fd.get('id'),
        selling_plan: fd.get('selling_plan'),
        quantity: fd.get('quantity'),
        checkedRadioVariant: document.querySelector('.pdp-plan-radio:checked')?.dataset.variantId,
        checkedRadioPlan: document.querySelector('.pdp-plan-radio:checked')?.value
      });
      window.MYOTIDE_Cart.addAndOpen(productForm, document.getElementById('pdp-add-to-cart'));
    });
  }

  // Buy Once: Same AJAX flow with separate form (one-time mode: MYO-001 × bag-count)
  const onetimeForm = document.getElementById('pdp-onetime-form');
  if (onetimeForm) {
    onetimeForm.addEventListener('submit', (ev) => {
      ev.preventDefault();
      syncQtyFromCheckedPlan(onetimeForm, 'pdp-onetime-qty', true);
      window.MYOTIDE_Cart.addAndOpen(onetimeForm, document.getElementById('pdp-buy-once'));
    });
  }

  // Sticky Cart button (mobile bottom bar)
  const stickyCartBtn = document.getElementById('pdp-sticky-cart-btn');
  if (stickyCartBtn) {
    stickyCartBtn.addEventListener('click', (e) => {
      const target = document.getElementById('choose-plan') || document.getElementById('pdp-hero');
      if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }

  // "Choose Your Plan" / "Try Risk-Free Today" CTAs (anywhere on PDP):
  // smooth-scroll to #choose-plan AND auto-select the data-plan-jump plan
  // (defaults to '3' = 3 Months) so the customer lands ready-to-add-to-cart.
  document.addEventListener('click', (e) => {
    const jumpLink = e.target.closest('[data-plan-jump]');
    if (!jumpLink) return;
    e.preventDefault();
    const wantedInterval = jumpLink.dataset.planJump || '3';
    const radio = document.querySelector('.pdp-plan-radio[data-interval="' + wantedInterval + '"]');
    if (radio) {
      const planEl = radio.closest('.pdp-plan');
      if (planEl && typeof selectPlan === 'function') {
        selectPlan(planEl);
      } else if (radio) {
        radio.checked = true;
        radio.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
    const target = document.getElementById('choose-plan');
    if (target) {
      // Slight delay to let radio state apply, then smooth-scroll
      setTimeout(() => {
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 50);
    }
  });
})();


/* ===========================================================
   CART DRAWER v2 - MYOTIDE_Cart global API
   - Event delegation (survives innerHTML replacement)
   - Plan dropdown switching (Monthly/3M/6M/OneTime)
   - Upgrade-to-Subscribe flow
   =========================================================== */
window.MYOTIDE_Cart = (function() {
  const DEBUG = true;
  const log = (...args) => { if (DEBUG) console.log('[Cart]', ...args); };
  const err = (...args) => console.error('[Cart]', ...args);

  const drawer = () => document.getElementById('cart-drawer');
  const backdrop = () => document.getElementById('cart-drawer-backdrop');

  function planIds() {
    const d = drawer();
    if (!d) return {};
    return {
      monthly: d.getAttribute('data-plan-monthly') || '',
      '3month': d.getAttribute('data-plan-3month') || '',
      '6month': d.getAttribute('data-plan-6month') || '',
      onetime: ''
    };
  }

  // Variant IDs per pack-size (MYO-001/002/003). Each Loop plan is bound to
  // one specific variant — switching plans means switching variants too.
  function variantIds() {
    const d = drawer();
    if (!d) return {};
    return {
      monthly:  d.getAttribute('data-variant-1bag') || '55960842633556',
      '3month': d.getAttribute('data-variant-3bag') || '55960842666324',
      '6month': d.getAttribute('data-variant-6bag') || '55960842699092',
      // For one-time we keep whatever variant the user currently has (= current bag count)
      onetime:  null
    };
  }

  function toast(msg, type) {
    let t = document.getElementById('cd-toast');
    if (!t) {
      t = document.createElement('div');
      t.id = 'cd-toast';
      t.style.cssText = 'position:fixed;top:20px;right:20px;z-index:9999;padding:14px 20px;border-radius:8px;font-size:13px;font-weight:600;box-shadow:0 8px 24px rgba(0,0,0,0.2);transition:opacity 0.3s;color:#fff;max-width:380px;';
      document.body.appendChild(t);
    }
    t.style.background = type === 'error' ? '#D04040' : '#2B7FE8';
    t.textContent = msg;
    t.style.opacity = '1';
    clearTimeout(t._timer);
    t._timer = setTimeout(() => { t.style.opacity = '0'; }, 3000);
  }

  // ═══════════════════════════════════════════════════════════════════════════
  // ⚠ iOS VIEWPORT-HEIGHT LOCK v6 (2026-05-28 · DO NOT REVERT WITHOUT TESTING)
  // ═══════════════════════════════════════════════════════════════════════════
  // Bug-history (regressed 4× already — keep this lock intact):
  //  · v1 CSS `top:0 + bottom:0`        → cream gap below cart on iOS
  //  · v2 CSS `100dvh`                  → shipping-bar cut off at top
  //  · v3 CSS `100lvh`                  → still iOS-version-dependent
  //  · v4 JS height (innerHeight)       → URL-bar collapse handled, but no zoom
  //  · v5 full visualViewport tracking  → BROKE pinch-zoom: cart shrunk in
  //                                       width/height during zoom → squished
  //                                       layout, text wrapped weird
  //  · v6 ⭐ THIS = JS height-only, scale-aware. Only updates when scale ≈ 1
  //                  (URL-bar collapse). During pinch-zoom (scale > 1) the cart
  //                  stays at full layout-viewport size — user naturally pans
  //                  within the zoomed cart, like Absorb-More/standard iOS UX.
  //
  // Three parts that MUST stay together:
  //  (a) setCartViewportHeight() — sets HEIGHT ONLY (no width/top/left tracking)
  //  (b) lockBodyScroll/unlockBodyScroll — iOS-safe scroll lock via position:fixed
  //  (c) visualViewport.resize listener (scale-aware) — only re-measures during
  //      URL-bar transitions, ignores zoom changes
  //
  // Don't:
  //   · re-add visualViewport.scroll listener (fires during zoom-pan → resize loop)
  //   · set width/top/left on cart (let CSS handle layout; JS only sets height)
  //   · use `overflow: hidden` on body (iOS scroll-jumps)
  //   · add `user-scalable=no` to viewport meta (a11y-hostile + Apple ignores)
  // ═══════════════════════════════════════════════════════════════════════════
  function setCartViewportHeight() {
    const d = drawer();
    const b = backdrop();
    const vv = window.visualViewport;
    // Skip re-measuring during pinch-zoom (scale > 1) — visualViewport.height
    // is the SMALLER zoomed-in viewable area, not the layout viewport. Keeping
    // the cart at its 1:1 height lets the user naturally pan around like
    // Absorb-More + every other iOS-native modal does.
    if (vv && vv.scale > 1.01) return;
    const h = (vv && vv.height) || window.innerHeight;
    if (d) d.style.height = h + 'px';
    if (b) b.style.height = h + 'px';
  }

  function clearCartViewportStyles() {
    const d = drawer();
    const b = backdrop();
    if (d) d.style.height = '';
    if (b) b.style.height = '';
  }

  // Body-scroll lock that works on iOS (vs `overflow:hidden` which jumps scroll)
  let savedScrollY = 0;
  function lockBodyScroll() {
    savedScrollY = window.scrollY || window.pageYOffset || 0;
    document.body.style.position = 'fixed';
    document.body.style.top = `-${savedScrollY}px`;
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.width = '100%';
  }
  function unlockBodyScroll() {
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    document.body.style.width = '';
    window.scrollTo(0, savedScrollY);
  }

  function open() {
    setCartViewportHeight();
    drawer()?.classList.add('open');
    drawer()?.setAttribute('aria-hidden', 'false');
    backdrop()?.classList.add('open');
    lockBodyScroll();
  }

  function close() {
    drawer()?.classList.remove('open');
    drawer()?.setAttribute('aria-hidden', 'true');
    backdrop()?.classList.remove('open');
    unlockBodyScroll();
    clearCartViewportStyles();
  }

  // Re-measure ONLY on URL-bar collapse/expand (no scroll listener — would
  // fire during pinch-zoom pan and create resize-loop).
  // setCartViewportHeight() guards internally against scale > 1.
  if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', () => {
      if (drawer()?.classList.contains('open')) setCartViewportHeight();
    });
  }
  window.addEventListener('resize', () => {
    if (drawer()?.classList.contains('open')) setCartViewportHeight();
  });
  window.addEventListener('orientationchange', () => {
    if (drawer()?.classList.contains('open')) setTimeout(setCartViewportHeight, 200);
  });

  // Gift reconcile (2026-07-21): gift qty must always equal the summed qty of
  // subscription Preserve-Stack lines (1 gift set per stack unit, any plan).
  // Idempotent — fixes missing gifts (drawer plan-switch paths), duplicate gift
  // lines (double form submits) and non-scaling qty. Runs before every drawer
  // re-render; never calls refresh() itself (no loop).
  let giftReconcilePromise = null;
  async function reconcileGifts() {
    const d = drawer(); if (!d) return;
    const stackPid = Number(d.getAttribute('data-stack-product-id') || 0);
    const giftIds = (d.getAttribute('data-gift-variants') || '')
      .split(',').map(s => Number(s.trim())).filter(Boolean);
    if (!stackPid || !giftIds.length) return;
    try {
      const cart = await fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(r => r.json());
      let want = 0;
      const stackSubLines = cart.items.filter(it => it.product_id === stackPid && it.selling_plan_allocation);
      stackSubLines.forEach(it => { want += it.quantity; });
      const giftLines = cart.items.filter(it => giftIds.includes(it.variant_id) && it.properties && it.properties['_subProduct']);
      const missing = giftIds.filter(vid => !giftLines.some(it => it.variant_id === vid));

      if (want > 0 && missing.length) {
        // A gift is missing entirely (drawer plan-switch removed the parent line
        // and its linked children). Rebuild stack + gifts in ONE add call — the
        // same shape the PDP form posts — so the checkout keeps the nested
        // parent/child grouping. Zero out stack sub-lines + leftover gift lines
        // first, then re-add together.
        const anchor = stackSubLines[0];
        const zero = {};
        stackSubLines.forEach(it => { zero[it.key] = 0; });
        giftLines.forEach(it => { zero[it.key] = 0; });
        if (Object.keys(zero).length) {
          await fetch('/cart/update.js', {
            method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ updates: zero })
          });
        }
        const items = [{
          id: anchor.variant_id,
          quantity: want,
          selling_plan: anchor.selling_plan_allocation.selling_plan.id
        }];
        giftIds.forEach(vid => {
          items.push({ id: vid, quantity: want, properties: { _subProduct: 'true' }, parent_id: anchor.variant_id });
        });
        const ar = await fetch('/cart/add.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items })
        });
        if (!ar.ok) {
          // Never lose the paid product: restore stack without gifts as fallback.
          await fetch('/cart/add.js', {
            method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [items[0]] })
          }).catch(() => {});
          await fetch('/cart/add.js', {
            method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: items.slice(1).map(({ parent_id, ...rest }) => rest) })
          }).catch(() => {});
        }
        return;
      }

      // No missing gifts -> just sync quantities in place (keeps existing
      // parent/child linkage) and zero duplicate lines.
      const updates = {};
      giftIds.forEach(vid => {
        const lines = giftLines.filter(it => it.variant_id === vid);
        if (!lines.length) return;
        if (want === 0 || lines[0].quantity !== want) updates[lines[0].key] = want;
        for (let i = 1; i < lines.length; i++) updates[lines[i].key] = 0;
      });
      if (Object.keys(updates).length) {
        await fetch('/cart/update.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ updates })
        });
      }
    } catch (e) {
      console.error('Gift reconcile failed:', e);
    }
  }
  function runGiftReconcile() {
    if (!giftReconcilePromise) {
      giftReconcilePromise = reconcileGifts().finally(() => { giftReconcilePromise = null; });
    }
    return giftReconcilePromise;
  }
  // If a reconcile is still in flight when the user hits checkout, finish it first.
  document.addEventListener('click', function (e) {
    const co = e.target.closest && e.target.closest('.cd-checkout');
    if (!co || !giftReconcilePromise) return;
    e.preventDefault();
    const dest = co.href || '/checkout';
    giftReconcilePromise.finally(() => { window.location.href = dest; });
  }, true);

  async function refresh() {
    try {
      await runGiftReconcile();
      const resp = await fetch('/?sections=cart-drawer', { headers: { Accept: 'application/json' } });
      if (!resp.ok) return;
      const data = await resp.json();
      const html = data['cart-drawer'];
      if (!html) return;
      const tmp = document.createElement('div');
      tmp.innerHTML = html;
      const newDrawer = tmp.querySelector('#cart-drawer');
      const cur = drawer();
      if (newDrawer && cur) {
        const wasOpen = cur.classList.contains('open');
        // Copy data-attributes for plan IDs
        ['planMonthly', 'plan3month', 'plan6month'].forEach(attr => {
          const dashed = attr.replace(/([A-Z])/g, '-$1').toLowerCase();
          const val = newDrawer.getAttribute('data-' + dashed);
          if (val) cur.setAttribute('data-' + dashed, val);
        });
        cur.innerHTML = newDrawer.innerHTML;
        if (wasOpen) cur.classList.add('open');
        cur.classList.remove('is-loading'); // busy state ends when fresh markup lands
      }
      // Update header cart badge with LOGICAL count (subs/plan_months)
      const cart = await fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(r => r.json());
      let logicalCount = 0;
      cart.items.forEach(it => {
        let m = 1;

        if (!it.properties['_subProduct']) {   // Dm - Changes || 15/07/26 Start =====
          if (it.selling_plan_allocation && it.selling_plan_allocation.selling_plan) {
            const pn = (it.selling_plan_allocation.selling_plan.name || '').toLowerCase();
            if (pn === '3-month') m = 3;
            else if (pn === '6-month') m = 6;
          }
          let logical = Math.floor(it.quantity / m);
          if (logical < 1) logical = 1;
          logicalCount += logical;
        }
      });
      // FIX (lock 2026-05-24): update badges in BOTH original header AND
      // floating clone — they share the cart count and must stay in sync.
      const cartTriggers = document.querySelectorAll('.header .icon-cart, .header-floating .icon-cart');
      cartTriggers.forEach(trigger => {
        let badge = trigger.querySelector('.icon-cart-badge');
        if (logicalCount > 0) {
          if (!badge) {
            badge = document.createElement('span');
            badge.className = 'icon-cart-badge';
            trigger.appendChild(badge);
          }
          badge.textContent = logicalCount;
        } else if (badge) {
          badge.remove();
        }
      });
    } catch (e) {
      console.error('Cart refresh failed:', e);
    }
  }

  async function addAndOpen(form, btn) {
    if (btn) btn.setAttribute('disabled', 'true');
    const formData = new FormData(form);
    try {
      const resp = await fetch('/cart/add.js', {
        method: 'POST', body: formData,
        headers: { Accept: 'application/json' }
      });
      if (!resp.ok) {
        const err = await resp.json().catch(() => ({}));
        alert('Could not add to cart: ' + (err.description || err.message || 'unknown error'));
        return;
      }
      await refresh();
      open();
    } catch (e) {
      alert('Network error: ' + e.message);
    } finally {
      if (btn) btn.removeAttribute('disabled');
    }
  }

  async function setQty(element, key, newQty) {
    log('setQty', { key, newQty });
    try {
      if (document.querySelector("#cart-drawer")) {
        document.querySelector("#cart-drawer").classList.add("is-loading");
      }

      const updates = { [key]: newQty };
      // const getSubKey = element.getAttribute('data-sub-products');
      // if (getSubKey) {
      //   const subKeys = getSubKey.split(",").map(k => k.trim());
      //   subKeys.forEach(k => {
      //     if (k) {          // only add if not empty
      //       updates[k] = 1;
      //     }
      //   });
      // }
      // const getRemoveSubKey = element.getAttribute('data-sub-remove-products');
      // if (getRemoveSubKey && getSubKey) {
      //   const subKeys = getRemoveSubKey.split(",").map(k => k.trim());
      //   subKeys.forEach(k => {
      //     if (k) {          // only add if not empty
      //       updates[k] = 0;
      //     }
      //   });
      // }
      const getSubKey = element.getAttribute('data-sub-products');
      const keepKeys = getSubKey
        ? getSubKey.split(",").map(k => k.trim()).filter(Boolean)
        : [];

      // Keep these products
      keepKeys.forEach(k => {
        updates[k] = 1;
      });

      const getRemoveSubKey = element.getAttribute('data-sub-remove-products');

      if (getRemoveSubKey) {
        const removeKeys = getRemoveSubKey
          .split(",")
          .map(k => k.trim())
          .filter(Boolean);

        removeKeys.forEach(k => {
          // Only set 0 if this key is NOT in keepKeys
          if (keepKeys.includes(k)) {
            updates[k] = 0;
          }
        });
      }
      const resp = await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({updates})
      });
      if (!resp.ok) {
        const e = await resp.json().catch(() => ({}));
        toast('Could not update quantity: ' + (e.description || e.message || resp.status), 'error');
        return;
      }
      if (document.querySelector("#cart-drawer")) {
        document.querySelector("#cart-drawer").classList.remove("is-loading");
      }
      await refresh();
    } catch (e) {
      err(e);
      toast('Network error: ' + e.message, 'error');
    }
  }

  async function removeItem(key) {
    log('removeItem', key);
    try {
      const resp = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: 0 })
      });
      if (!resp.ok) {
        const e = await resp.json().catch(() => ({}));
        toast('Could not remove item: ' + (e.description || e.message || resp.status), 'error');
        return;
      }
      log('Removed, refreshing');
      await refresh();
    } catch (e) {
      err(e);
      toast('Network error: ' + e.message, 'error');
    }
  }

  async function changePlan(itemEl, planKey, extraFreeBies) {
    log('changePlan', { planKey });
    try {
      if (document.querySelector("#cart-drawer")) {
        document.querySelector("#cart-drawer").classList.add("is-loading");
      }
      const key = itemEl.dataset.key;
      const plankey = itemEl.dataset.plankey;
      const currentVariantId = itemEl.dataset.variantId;
      log('item data', { key, currentVariantId });
      if (!key) { err('Missing data-key'); return; }

      const cart = await fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(r => r.json());
      // Key can go stale when the gift-reconcile rebuilt lines after render —
      // fall back to matching the (non-gift) line by variant id.
      const item = cart.items.find(i => i.key === key)
        || cart.items.find(i => String(i.variant_id) === String(currentVariantId) && !(i.properties && i.properties['_subProduct']));
      if (!item) { err('Item not found in cart'); return; }
      const lineKey = item.key;

      const ids = planIds();
      const vars = variantIds();
      log('Plan IDs:', ids, 'Variant IDs:', vars);

      const newPlanId    = ids[planKey] || '';

      // ── Bag-count preservation across One-Time switches (lock 2026-06-29) ──────────
      // Subs encode pack-size in the VARIANT (MYO-001=1 · MYO-002=3 · MYO-003=6 bags),
      // always qty 1. One-Time uses MYO-001 (single bag) × qty. To keep the customer's
      // TOTAL supply constant we convert via bag-count: total = bagsOf(variant) × qty.
      //   · → One-Time:       MYO-001 × total              (6-Month ×1 → 6× one-time bags)
      //   · One-Time → Sub:   planVariant × round(total / planBags)  (6 one-time → 6-Month ×1)
      //   · Sub → Sub:        qty 1 (each sub = its own pack · out of scope)
      const bagsOf = (vid) => {
        const v = String(vid);
        if (v === String(vars['6month'])) return 6;
        if (v === String(vars['3month'])) return 3;
        return 1; // MYO-001 / monthly variant / default single bag
      };
      const curBags    = bagsOf(item.variant_id) * (item.quantity || 1);
      const wasOnetime = !item.selling_plan_allocation;

      let newVariantId, newQty;
      if (planKey === 'onetime') {
        newVariantId = vars.monthly || '55960842633556';             // MYO-001 single bag
        newQty       = Math.max(1, curBags);
      } else {
        newVariantId = vars[planKey] || currentVariantId;
        newQty       = wasOnetime
          ? Math.max(1, Math.round(curBags / bagsOf(newVariantId)))  // One-Time → Sub: preserve supply
          : 1;                                                       // Sub → Sub: unchanged
      }
      log('Switching to:', { planKey, newPlanId, newVariantId, newQty, curBags, wasOnetime });

      // Remove current line
      const rmResp = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: lineKey, quantity: 0 })
      });
      if (!rmResp.ok) {
        const e = await rmResp.json().catch(() => ({}));
        toast('Plan change failed (remove): ' + (e.description || rmResp.status), 'error');
        return;
      }

      // Re-add with new variant + selling_plan

      // Dm - Changes || 15/07/26 Start =====
      let body = {
        items: [{
          id: newVariantId,
          quantity: newQty,
           ...(newPlanId && { selling_plan: parseInt(newPlanId) })
        }]
      };
      // Dm - Changes || 15/07/26 End =====

      // const body = { id: parseInt(newVariantId), quantity: newQty };
      // if (newPlanId) body.selling_plan = parseInt(newPlanId);
      
      // Dm - Changes || 15/07/26 Start =====
      if (wasOnetime) {
        if (plankey !== 'onetime') {
          if (extraFreeBies && extraFreeBies.length && newPlanId) {
            extraFreeBies.forEach((item) => {
              body.items.push({
                id: parseInt(item),
                quantity: 1,
                parent_id: newVariantId,
                properties: {
                  _subProduct: true,
                },
              });
            });
          }
        }
      }
      // Dm - Changes || 15/07/26 End =====
      
      log('Re-adding:', body);
      const addResp = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      });
      if (!addResp.ok) {
        const e = await addResp.json().catch(() => ({}));
        toast('Plan change failed (re-add): ' + (e.description || addResp.status), 'error');
        return;
      }

    } catch (e) {
      err(e);
      toast('Network error: ' + e.message, 'error');
    } finally {
      // Always end the busy state and re-render the real cart — even after an
      // early error return. refresh() runs the gift-reconcile, so a half-done
      // plan switch self-heals instead of leaving a stuck "UPDATING…" drawer.
      await refresh();
      const dEl = drawer();
      if (dEl) dEl.classList.remove('is-loading');
    }
  }

  async function upgradeToSubscribe(extraFreeBies) {
    log('upgradeToSubscribe');
    try {
      if (document.querySelector("#cart-drawer")) {
        document.querySelector("#cart-drawer").classList.add("is-loading");
      }
      const cart = await fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(r => r.json());
      const ids = planIds();
      const vars = variantIds();
      const targetPlan    = ids['3month'];
      const targetVariant = vars['3month'];
      log('Target plan + variant:', { targetPlan, targetVariant });
      if (!targetPlan) { toast('Auto-Refill plan not available', 'error'); return; }


      // Dm - Changes || 15/07/26 Start =====
      let body = {
        items: [{
          id: targetVariant,
          quantity: 1,
           ...(targetPlan && { selling_plan: parseInt(targetPlan) })
        }]
      };

      // Dm - Changes || 15/07/26 Start =====
      if (extraFreeBies && extraFreeBies.length && targetPlan) {
        extraFreeBies.forEach((item) => {
          body.items.push({
            id: parseInt(item),
            quantity: 1,
            parent_id: targetVariant,
            properties: {
              _subProduct: true,
            },
          });
        });
      }
      // Dm - Changes || 15/07/26 End =====
      // Dm - Changes || 15/07/26 End =====

      // Snapshot items first since we'll mutate cart
      const oneTimeItems = cart.items.filter(i => !i.selling_plan_allocation && !item.properties?._subProduct);
      log('OneTime items to convert:', oneTimeItems.length);

      for (const item of oneTimeItems) {
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: item.key, quantity: 0 })
        });
        // Upgrade to 3-month sub (default): switch variant to MYO-002 + qty=1 + 3-month plan.
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(body)
        });
      }
      if (document.querySelector("#cart-drawer")) {
        document.querySelector("#cart-drawer").classList.remove("is-loading");
      }
      await refresh();
    } catch (e) {
      err(e);
      toast('Upgrade failed: ' + e.message, 'error');
    }
  }

  // Single event-delegation handler on document
  document.addEventListener('click', (e) => {
    // Close button (X)
    const closeBtn = e.target.closest('[data-action="close"]');
    if (closeBtn && closeBtn.closest('#cart-drawer')) {
      log('click: close');
      close();
      return;
    }

    // Upgrade to subscribe button
    const upgradeBtn = e.target.closest('[data-action="upgrade-to-sub"]');
    if (upgradeBtn) {
      log('click: upgrade-to-sub');
      upgradeBtn.setAttribute('disabled', 'true');
      // Dm - Changes || 15/07/26 Start =====
      var extraFreeBies = [];
      const freebiesId = upgradeBtn.getAttribute('data-extra-product');
      if (freebiesId) {
        extraFreeBies = freebiesId.split(',');
      }
      // Dm - Changes || 15/07/26 End =====
      upgradeToSubscribe(extraFreeBies).finally(() => upgradeBtn.removeAttribute('disabled'));
      return;
    }

    const drawerEl = drawer();
    if (!drawerEl) return;

    // Plan toggle (open/close dropdown)
    const planToggle = e.target.closest('[data-action="toggle-plan"]');
    if (planToggle) {
      log('click: toggle-plan');
      e.stopPropagation();
      const itemEl = planToggle.closest('.cd-item');
      const isOpen = planToggle.getAttribute('aria-expanded') === 'true';
      // Close ALL plan menus first
      drawerEl.querySelectorAll('.cd-plan-menu').forEach(m => { m.hidden = true; });
      drawerEl.querySelectorAll('[data-action="toggle-plan"]').forEach(b => b.setAttribute('aria-expanded', 'false'));
      if (!isOpen && itemEl) {
        const menu = itemEl.querySelector('.cd-plan-menu');
        if (menu) {
          menu.hidden = false;
          planToggle.setAttribute('aria-expanded', 'true');
          log('Opened dropdown for item', itemEl.dataset.key);
        }
      }
      return;
    }

    // Plan option select (within dropdown)
    const planOpt = e.target.closest('.cd-plan-option');
    if (planOpt) {
      log('click: plan-option', planOpt.dataset.planKey);
      e.stopPropagation();
      const itemEl = planOpt.closest('.cd-item');
      // Dm - Changes || 15/07/26 Start =====
      var extraFreeBies = [];
      const freebiesId = planOpt.getAttribute('data-extra-product');
      if (freebiesId) {
        extraFreeBies = freebiesId.split(',');
      }

      console.log(extraFreeBies,"extraFreeBiesextraFreeBiesextraFreeBiesextraFreeBiesextraFreeBiesextraFreeBies")
      
      // Dm - Changes || 15/07/26 End =====
      if (itemEl) {
        const planKey = planOpt.dataset.planKey;
        changePlan(itemEl, planKey, extraFreeBies);
      }
      return;
    }

    // Click outside drawer (or in body area) — close plan menus
    if (!e.target.closest('.cd-plan-menu') && !e.target.closest('[data-action="toggle-plan"]')) {
      drawerEl.querySelectorAll('.cd-plan-menu').forEach(m => { m.hidden = true; });
      drawerEl.querySelectorAll('[data-action="toggle-plan"]').forEach(b => b.setAttribute('aria-expanded', 'false'));
    }
  });

  // Qty-Set: dropdown change event (0 = remove). New model: cart qty = display qty (no multiplier).
  document.addEventListener('change', (e) => {
    const sel = e.target.closest('[data-action="qty-set"]');
    if (!sel) return;
    const itemEl = sel.closest('.cd-item');
    if (!itemEl) return;
    const displayQty = parseInt(sel.value, 10);
    log('change: qty-set', { displayQty });
    setQty(sel,itemEl.dataset.key, displayQty);
  });

  // Empty-state product-add form submit → AJAX add + drawer stays open
  document.addEventListener('submit', (e) => {
    const form = e.target.closest('.cd-empty-product-form');
    if (!form) return;
    e.preventDefault();
    const btn = form.querySelector('.cd-empty-product-add');
    addAndOpen(form, btn);
  });

  document.addEventListener('DOMContentLoaded', () => {
    // Backdrop click + ESC + header cart icon
    const back = backdrop();
    if (back) back.addEventListener('click', close);

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && drawer()?.classList.contains('open')) close();
    });

    // Cart-trigger via event delegation — handles both original AND floating-clone cart buttons
    document.addEventListener('click', (e) => {
      const trigger = e.target.closest('.icon-cart');
      if (!trigger) return;
      if (!trigger.closest('.header, .header-floating')) return;
      e.preventDefault();
      open();
    });
  });

  return { open, close, refresh, addAndOpen };
})();

/* Header cart badge styling */
(function() {
  if (document.getElementById('myotide-cart-badge-styles')) return;
  const style = document.createElement('style');
  style.id = 'myotide-cart-badge-styles';
  style.textContent = `
    .icon-cart { position: relative; }
    .icon-cart-badge {
      position: absolute;
      top: -2px; right: -2px;
      min-width: 18px; height: 18px;
      padding: 0 5px;
      background: var(--accent-blue-deep);
      color: var(--white);
      border-radius: 999px;
      font-size: 10px;
      font-weight: 700;
      display: flex;
      align-items: center;
      justify-content: center;
      letter-spacing: 0;
    }
  `;
  document.head.appendChild(style);
})();
